export class Search  {
        public Results: Result[];
        public Relateds: string[];
	public Start: number;
        public Total: number;
        public PageSize: number;
        public MaxSize: number;
	public Time: string = "0.27";
}

export class Result  {
        public Title: string;
        public Url: string;
        public Text: string;
	public Rank: number;
}



// WEBPACK FOOTER //
// ./src/app/admin/adminSearch/model/search.ts